
<template>
  <div id="upload">
      <Menutop></Menutop>
      <div class="row container">
        <div class="col">

          <h1>Upload von Covers</h1>
          <p v-show="!vorgang_wurde_gestartet">Bereit für neuen Vorgang</p>
          <p v-show="vorgang_wurde_gestartet">Wir sind in Vorgang {{ selected_customer }}/{{ vorgang_id }}</p>
            
            <div class="container">
              <div class="row">
                <div class="col-sm">
                  <h2>Customer</h2>
                  <label>
                    <b-form-select v-model="selected_customer" :options="possible_customers" size="5">
                    </b-form-select>
                  </label>
                  <b-button @click="api_vorgang_starten" v-show="! vorgang_wurde_gestartet" type="button" class="btn btn-primary btn-lg btn-block">Starte neuen Vorgang</b-button>
                  <b-button @click="api_vorgang_beenden" 
                    v-show="vorgang_wurde_gestartet"
                    :disabled="!(barcode_is_uploaded && cover_is_uploaded)" type="button" class="btn btn-primary btn-lg btn-block">Vorgang beenden</b-button>
                  <b-button @click="api_vorgang_abbrechen" v-show="vorgang_wurde_gestartet" type="button" class="btn btn-warning btn-lg btn-block">Vorgang abbrechen</b-button>
                </div>

                <div class="col-sm">
                  <h2>Barcode</h2>
                  <vue-dropzone ref="ref_dropzone_barcode" 
                    id="dropzone_barcode" 
                    :options="dropzone_options_barcode"
                    v-on:vdropzone-file-added="file_dropped_on_barcode"
                    v-show="vorgang_wurde_gestartet">
                  </vue-dropzone>
                  <p v-show="! vorgang_wurde_gestartet">Noch nicht...</p>
                  <p v-show="vorgang_wurde_gestartet">gif oder jpg, ean oder büchereicode</p>
                </div>

                <div class="col-sm">
                  <h2>Cover</h2>
                  <vue-dropzone ref="ref_dropzone_cover" 
                    id="dropzone_cover" 
                    :options="dropzone_options_cover"
                    v-on:vdropzone-file-added="file_dropped_on_cover"
                    v-show="vorgang_wurde_gestartet">
                    </vue-dropzone>
                    <p v-show="! vorgang_wurde_gestartet">Noch nicht...</p>
                </div>


              </div>
            </div>


        </div>

      
      </div>
      
      <Footer></Footer>
  </div>
</template>

<script>
import Menutop from '../components/Menutop.vue';
import Footer from '../components/Footer.vue';
// kommt von pinegrow/bootstrap4:
import '../components/sticky-footer-navbar.css';
import axios from 'axios';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

// Mixin fuer diese Komponente importieren
import loginzustand from './mixins/loginzustand.js';
import commonvars from './mixins/commonvars.js';

export default {
  name: 'Uploadcover',
  components: {
    Menutop,
    Footer,
    vueDropzone: vue2Dropzone
  },
  mixins: [
    loginzustand,
    commonvars
  ],
  data() {
    return {
      customer: this.$route.params.customer,

      possible_customers: [
      ],
      selected_customer: "",
      vorgang_id: -1,
      vorgang_wurde_gestartet: false,
      dropzone_options_barcode: {
        url:  this.upload_barcode_default_url(),
        thumbnailWidth: 200,
        maxFilesize: 0.5,
        dictDefaultMessage: "Barcode"
      },
      dropzone_options_cover: {
        url:  this.upload_cover_default_url(),
        thumbnailWidth: 200,
        maxFilesize: 2.5,
        dictDefaultMessage: "Cover"
      },
      upload_cover_url: "dummy",
      upload_barcode_url: "dummy",
      cover_is_uploaded: false,
      barcode_is_uploaded: false
    }
  },
  mounted: function() {
    console.log("Hier ist Uploadcover/mounted");
    this.setze_access_token_aus_localstorage_in_axios_header();
    this.api_customers_alle_holen();
    this.api_loginzustand_feststellen();
  },
  methods: {
    api_vorgang_starten() {
      console.log("Starte neuen Vorgang");
      axios.post(this.api_vorgang_starten_url())
        .then(
          response => {
            this.vorgang_id = response.data.vorgang_id;
            this.vorgang_wurde_gestartet = true;
            console.log("Vorgang " + this.vorgang_id + " wurde gestartet");
            this.upload_urls_fuer_dropzones_auf_customer_und_vorgang_einstellen();
          }
        )
        .catch(
          () => {
            console.log("unauthorized -> login");
            this.$router.push("/login");
          }
        );
    },
    api_vorgang_beenden() {
      let alte_vorgang_id = this.vorgang_id;
      console.log("Beende Vorgang mit " + this.api_vorgang_beenden_url());
      axios.post(this.api_vorgang_beenden_url())
        .then(
          // response wird nicht gebraucht:
          // eslint-disable-next-line
          response => {
            console.log("Vorgang " + alte_vorgang_id + " wurde beendet");
            this.vorgang_id = -1;
            this.vorgang_wurde_gestartet = false;
            this.upload_urls_fuer_dropzones_auf_default_setzen();
          }
        )
        .catch(
          () => {
            console.log("unauthorized -> login");
            this.$router.push("/login");
          }
        );
      this.vorgang_id = -1;
      this.vorgang_wurde_gestartet = false;
      this.cover_is_uploaded = false;
      this.barcode_is_uploaded = false;
      // removeAllFiles löscht NICHT die Files auf dem Server
      // sondern resettet das Objekt
      this.$refs.ref_dropzone_cover.removeAllFiles();
      this.$refs.ref_dropzone_barcode.removeAllFiles();
    },
    api_vorgang_abbrechen() {
      let alte_vorgang_id = this.vorgang_id;
      console.log("Breche Vorgang ab mit " + this.api_vorgang_abbrechen_url());
      axios.post(this.api_vorgang_abbrechen_url())
        .then(
          // response wird nicht gebraucht:
          // eslint-disable-next-line
          response => {
            console.log("Vorgang " + alte_vorgang_id + " wurde abgebrochen");
            this.vorgang_id = -1;
            this.vorgang_wurde_gestartet = false;
            this.upload_urls_fuer_dropzones_auf_default_setzen();
          }
        )
        .catch(
          () => {
            console.log("unauthorized -> login");
            this.$router.push("/login");
          }
        );
      this.vorgang_id = -1;
      this.vorgang_wurde_gestartet = false;
      this.cover_is_uploaded = false;
      this.barcode_is_uploaded = false;
    },
    api_vorgang_abbrechen_url() {
      return this.server_base_url()
        + "/cover/upload/" + this.selected_customer 
        + "/vorgang/" + this.vorgang_id + "/abbrechen";
    },
    upload_urls_fuer_dropzones_auf_customer_und_vorgang_einstellen() {
      // Stelle die Upload-URLs für beide Dropzones richtig

      // Cover:
      let upload_cover_url = this.server_base_url()
        + "/cover/upload/" + this.selected_customer 
        + "/vorgang/" + this.vorgang_id + "/cover.jpg";
      this.upload_cover_url = upload_cover_url;
      this.$refs.ref_dropzone_cover.setOption('url', this.upload_cover_url);
      console.log("ref_dropzone_cover geändert auf: " + this.upload_cover_url);
      // Dropzone macht sein Upload nicht mit Axios, deshalb hier den 
      // Header extra setzen
      this.$refs.ref_dropzone_cover.setOption(
        'headers', { 
          'Authorization': localStorage.getItem('access_token') }
      );

      // Barcode:
      let upload_barcode_url = this.server_base_url()
        + "/cover/upload/" + this.selected_customer 
        + "/vorgang/" + this.vorgang_id + "/barcode.jpg";
      this.upload_barcode_url = upload_barcode_url;
      this.$refs.ref_dropzone_barcode.setOption('url', this.upload_barcode_url);
      console.log("ref_dropzone_barcode geändert auf: " + this.upload_barcode_url);
      // Dropzone macht sein Upload nicht mit Axios, deshalb hier den 
      // Header extra setzen
      this.$refs.ref_dropzone_barcode.setOption(
        'headers', { 
          'Authorization': localStorage.getItem('access_token') }
      );
    },
    upload_urls_fuer_dropzones_auf_default_setzen() {
      this.upload_cover_url = this.upload_cover_default_url();
      this.upload_barcode_url = this.upload_barcode_default_url();
    },
    api_vorgang_starten_url() {
      return this.server_base_url() + "/cover/upload/" + this.selected_customer + "/vorgang/starten";
    },
    api_vorgang_beenden_url() {
      return this.server_base_url() + "/cover/upload/" + this.selected_customer 
        + "/vorgang/" + this.vorgang_id + "/beenden";
    },
    file_dropped_on_barcode(file) {
      console.log("File " + file.name + " dropped on barcode, URL zum Upload ist: " + this.upload_barcode_url);
      this.barcode_is_uploaded = true;
    },
    file_dropped_on_cover(file) {
      console.log("File " + file.name + " dropped on cover, URL zum Upload ist: " + this.upload_cover_url);
      this.cover_is_uploaded = true;
    },
    upload_cover_default_url() {
      return "dummy";
    },
    upload_barcode_default_url() {
      return "dummy";
    },
    get_customers_alle_api_url() {
      return this.server_base_url() + "/api/customers/alle";
    },
    api_customers_alle_holen() {
      let url = this.get_customers_alle_api_url();
      console.log("Hole alle customers mit " + url);
      axios.get(url)
        .then(
          response => {
            this.possible_customers = response.data.customers;
            this.selected_customer = this.possible_customers[0];
          }
        )
        .catch(
          () => {
            console.log("unauthorized -> login");
            this.$router.push("/login");
          }
        );
    },
  }
}

</script>

<style scoped>
</style>


